var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work-order",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP-Home-Page---permits-handed-back",
    transform: "translate(-31.000000, -209.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(29.000000, 205.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_info-:-20px",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "holder",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("circle", {
    id: "shape",
    fill: "#4C4C4C",
    cx: 13.05,
    cy: 9.45,
    r: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3,17.1 C16.5,17.1 16.5,18.9 15.3,18.9 L11.7,18.9 C11.2029437,18.9 10.8,18.4970563 10.8,18 C10.8,17.5029437 11.2029437,17.1 11.7,17.1 L12.6,17.1 L12.6,13.5 L11.7,13.5 C11.2029437,13.5 10.8,13.0970563 10.8,12.6 C10.8,12.1029437 11.2029437,11.7 11.7,11.7 L13.5,11.7 C13.9970563,11.7 14.4,12.1029437 14.4,12.6 L14.4,17.1 L15.3,17.1 Z",
    id: "shape",
    fill: "#4C4C4C",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    cx: 13,
    cy: 14.5,
    r: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackInfoIcon);
export default __webpack_public_path__ + "static/media/BlackInfoIcon.3e9da53d65d144265f5c2d5a19e51b6d.svg";
export { ForwardRef as ReactComponent };